export default __webpack_public_path__ + "locales/el-GR/DeleteThirdPartyDialog.json?hash=e947cb20c083ccfb2500605be4e14168";